<template>
  <div class="page">
    <top :open-audio="openAudio" @openCloseAudio="openCloseAudio"></top>
    <router-view />
  </div>
</template>

<script>
import top from "./top";
import { newWebSocket } from "../plugins/bwWebSocket";
import { wsUrl } from "../plugins/BsaeUrl";

export default {
  name: "layOut",
  components: { top },
  data () {
    return {
      openAudio: false,
      wsConnected: false, // WebSocket连接状态
      reconnectAttempts: 0 // 重连尝试次数
    }
  },
  mounted() {
    this.createWebSocket()
  },
  beforeDestroy() {
    // 组件销毁时关闭WebSocket连接
    this.closeWebSocket()
  },
  methods: {
    createWebSocket () {
      // 如果已经有连接，先关闭
      if (newWebSocket.websocket) {
        newWebSocket.close()
      }
      
      newWebSocket.init({
        url: wsUrl,
        onopen: (msg, data) => {
          console.log('WebSocket连接成功:', msg, data)
          this.wsConnected = true
          this.reconnectAttempts = 0
        },
        onmessage: (data) => {
          console.log('收到WebSocket消息:', data)
          this.$bus.emit('refreshWarning')
          if (this.openAudio) {
            this.playerAudio()
          }
        },
        onclose: (msg) => {
          console.log('WebSocket连接关闭:', msg)
          this.wsConnected = false
          
          // 如果包含重连信息，更新重连次数
          if (msg.includes('重连')) {
            this.reconnectAttempts++
          }
        },
        onerror: (msg) => {
          console.error('WebSocket连接错误:', msg)
          this.wsConnected = false
        }
      })
    },
    
    openCloseAudio () {
      this.openAudio = !this.openAudio
    },
    
    playerAudio() {
      try {
        const mp3Url = require('../assets/mp3/warnning.mp3')
        const player = new Audio(mp3Url);
        player.play().catch(error => {
          console.error('音频播放失败:', error)
        });
      } catch (error) {
        console.error('音频文件加载失败:', error)
      }
    },
    
    // 手动重连
    reconnectWebSocket() {
      console.log('手动重连WebSocket')
      newWebSocket.resetReconnect()
      this.createWebSocket()
    },
    
    // 关闭WebSocket
    closeWebSocket() {
      newWebSocket.close()
      this.wsConnected = false
      this.reconnectAttempts = 0
    }
  }
}
</script>

<style scoped>
.page{
  background-image: url("../assets/img/bg.png");
  color: #FFFFFF;
  background-size: 100% 100%;
  width: 100vw;
  height: 100vh;
}
</style>
